<template>
    <div>
        <el-row :gutter="20">
            <el-col :md="{span:16, offset: 4}">
                <h2 style="margin-top:unset;">Courier</h2>
                <el-card shadow="never" style="padding-bottom:20px;">
                    <el-row>
                        <el-col class="text-md-left" :span="24">
                            <el-form :inline="true" @submit.native.prevent="() => {}">
                                <el-form-item label="เลือกขนส่ง">
                                    <el-select
                                        v-model="selProvider"
                                        @change="fetchCourierAccount"
                                        placeholder="ผู้ให้บริการ">
                                        <el-option
                                            v-for="item in listProvider"
                                            :key="item.courierProviderId"
                                            :label="item.name"
                                            :value="item.courierProviderId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col class="text-md-right" :span="24">
                            <el-button size="small" type="success"
                                @click="addingDialogVisible = true"
                                :disabled="selProvider == null">เพิ่ม</el-button>
                            <el-button size="small" type="danger"
                                :disabled="selectedAcc.length === 0"
                                @click="deleteCourierAccount"
                                :loading="deleteAccLoading">ลบ</el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col class="text-md-left">
                            <el-table
                                @selection-change="updateSelectedAcc"
                                v-loading="loadingAccList"
                                :data="courierAccList"
                                stripe
                                :default-sort = "{prop: 'courierAccountId', order: 'descending'}"
                                :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                                style="width: 100%">
                                <el-table-column
                                type="selection"
                                width="55">
                                </el-table-column>
                                <el-table-column label="Id" width="55">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{ scope.row.courierAccountId }}
                                    </div>
                                </el-table-column>
                                <el-table-column label="ชื่อผู้ให้บริการ" >
                                    <div class="text-md-left" slot-scope="scope">
                                        {{ scope.row.name }}
                                    </div>
                                </el-table-column>
                                <el-table-column label="Shipper ID" >
                                    <div class="text-md-left" slot-scope="scope">
                                        {{ scope.row.apiData ? scope.row.apiData.shipperCode : '-' }}
                                    </div>
                                </el-table-column>
                                <el-table-column label="ผู้ใช้งาน" >
                                    <div class="text-md-left" slot-scope="scope">
                                        <!-- {{ scope.row.apiData.username }} -->
                                        {{ scope.row.apiData ? scope.row.apiData.username : '-' }}
                                    </div>
                                </el-table-column>
                                <el-table-column label="รหัสผ่าน">
                                    <div slot-scope="scope">
                                        <div v-if="scope.row.apiData">
                                            <a
                                                @click.stop="showPassword(scope.$index)"
                                                style="color:#409EFF; text-decoration: none;"
                                                v-if="!passwordShowed[scope.$index]">
                                                show
                                            </a>

                                            <span v-else>
                                                {{scope.row.apiData.password}}
                                                (
                                            <a
                                                @click.stop="hidePassword(scope.$index)"
                                                style="color:#409EFF; text-decoration: none;">
                                                hide
                                            </a>)
                                            </span>
                                        </div>
                                        <div v-else>
                                            -
                                        </div>
                                    </div>
                                </el-table-column>
                            </el-table>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>

        <el-dialog
            :title="`Add courier account (${selCourierName})`"
            :visible.sync="addingDialogVisible"
            :before-close="handleClose"
            width="30%">
            <el-form ref="rulesCreateAccount" label-width="120px" :rules="rulesCreateAccount" :model="creatingAccount">
                <el-form-item label="Account name" prop="name">
                    <el-input v-model="creatingAccount.name"></el-input>
                </el-form-item>
                <el-form-item label="Shipper id">
                    <el-input v-model="creatingAccount.apiData.shipperCode"></el-input>
                </el-form-item>
                <el-form-item label="Username">
                    <el-input v-model="creatingAccount.apiData.username"></el-input>
                </el-form-item>
                <el-form-item label="Password">
                    <el-input v-model="creatingAccount.apiData.password"></el-input>
                </el-form-item>
                <el-button type="primary" @click="createCourierAccount"
                :loading="createAccLoading">Submit</el-button>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'ScgManagement',
    props: {
        courierProvider: Object
    },
    data () {
        return {
            listProvider: [],
            selProvider: null,
            courierAccList: [],
            loadingAccList: false,
            passwordShowed: [],
            addingDialogVisible: false,
            creatingAccount: {
                name: '',
                apiData: {
                    shipperCode: '',
                    username: '',
                    password: ''
                }
            },
            selectedAcc: [],
            createAccLoading: false,
            deleteAccLoading: false,
            rulesCreateAccount: {
                name: [
                    { required: true, message: 'กรุณากรอก Account name', trigger: 'blur' }
                ]
            },
            unDelete: [9, 41, 42, 43, 44]
        }
    },
    computed: {
        selCourierName () {
            if (this.listProvider.length > 0 && this.selProvider != null) {
                return this.listProvider.find(e => e.courierProviderId === this.selProvider).name
            }
            return ''
        }
    },
    created () {
        this.fetchListProvider()
    },
    methods: {
        async fetchListProvider () {
            let res = await fgApi.courier.getListProvider()
            this.listProvider = res.data
        },
        async fetchCourierAccount () {
            this.loadingAccList = true
            let param = {
                courier_provider_id: this.selProvider
            }
            let res = await fgApi.courier.getCourierAccount(param)
            console.log('res', res)
            // this.courierAccList = res.data.filter(e => e.deletedAt == null)

            let CourierArrayNewMap = []
            res.data.forEach(e => {
                if (this.unDelete.indexOf(e.courierAccountId) === -1) {
                    CourierArrayNewMap.push(e)
                }
            })
            this.courierAccList = CourierArrayNewMap
            console.log('CourierArrayNewMap', CourierArrayNewMap)
            this.passwordShowed = res.data.map(e => false)
            this.loadingAccList = false
        },
        createCourierAccount () {
            this.createAccLoading = true
            // console.log(this.$refs['rulesCreateAccount'])
            this.$refs['rulesCreateAccount'].validate(async (valid) => {
                if (valid) {
                    // this.creatingAccount.name = this.creatingAccount.name.trim()
                    // console.log(this.creatingAccount)

                    let param = {}
                    if (this.creatingAccount.apiData.shipperCode && this.creatingAccount.apiData.username && this.creatingAccount.apiData.password) {
                        // this.creatingAccount.apiData.shipperCode = this.creatingAccount.apiData.shipperCode.trim()
                        // this.creatingAccount.apiData.username = this.creatingAccount.apiData.username.trim()
                        // this.creatingAccount.apiData.password = this.creatingAccount.apiData.password.trim()
                        param = {
                            name: this.creatingAccount.name.replace(/\s/g, ''),
                            apiData: {
                                shipperCode: this.creatingAccount.apiData.shipperCode.replace(/\s/g, ''),
                                username: this.creatingAccount.apiData.username.replace(/\s/g, ''),
                                password: this.creatingAccount.apiData.password.replace(/\s/g, '')
                            },
                            courierId: this.selProvider
                        }
                    } else {
                        param = {
                            name: this.creatingAccount.name.replace(/\s/g, ''),
                            courierId: this.selProvider
                        }
                        delete this.creatingAccount.apiData
                    }
                    // console.log(this.creatingAccount)
                    // console.log(Object.assign(this.creatingAccount, { courierId: this.selProvider }))
                    // console.log(param)
                    let res = await fgApi.courier.createCourierAccount(param)
                    if (res.success === false) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Add courier account error'
                        })
                    } else {
                        this.$notify({
                            title: 'Success',
                            message: 'Add courier account success',
                            type: 'success'
                        })

                        this.fetchCourierAccount()
                        this.addingDialogVisible = false
                    }
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: 'Add courier account error'
                    })
                }
            })
            this.creatingAccount = {
                name: '',
                apiData: {
                    shipperCode: '',
                    username: '',
                    password: ''
                }
            }
            this.$refs['rulesCreateAccount'].resetFields()
            this.createAccLoading = false
            // this.addingDialogVisible = false
        },
        async deleteCourierAccount () {
            this.deleteAccLoading = true
            let res = await fgApi.courier.deleteCourierAccount({ courierAccountIds: this.selectedAcc })
            if (res.success === false) {
                this.$notify.error({
                    title: 'Error',
                    message: 'Delete courier account error'
                })
            } else {
                this.$notify({
                    title: 'Success',
                    message: 'Delete courier account success',
                    type: 'success'
                })
                this.fetchCourierAccount()
            }
            this.deleteAccLoading = false
        },
        updateSelectedAcc (val) {
            this.selectedAcc = val.map(e => e.courierAccountId)
        },
        showPassword (index) {
            this.$set(this.passwordShowed, index, true)
        },
        hidePassword (index) {
            this.$set(this.passwordShowed, index, false)
        },
        handleClose (done) {
            done()
            this.creatingAccount = {
                apiData: {}
            }
            this.$refs['rulesCreateAccount'].resetFields()
        }

    }
}
</script>
